import './styles.sass';

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import FilterSet from 'components/Explorer/models/filter_set';
import AutocompleteField from 'components/Explorer/AutocompleteField';
import useFilterLookup from 'hooks/useFilterLookup';
import JournalList from './JournalList';
import HelpLink from '../HelpLink';

const ANALYTICS_FIELD_NAME = 'Journal';

const JournalFilter = ({ filterSet, initialSearch }) => {
  const [, forceUpdate] = useState(0);

  const journalIds = filterSet.get('journal_id[]');
  const autocompleteFieldRef = useRef(null);

  const { data, loading } = useFilterLookup('filters/journal_names', { enabled: journalIds.length > 0 });
  const journals = data ?? [];

  useEffect(() => {
    if (!autocompleteFieldRef.current) return;
    if (!journalIds.length) autocompleteFieldRef.current.clearAll();
  }, [journalIds.length]);

  const updateSelectedJournals = (selected) => {
    filterSet.set(
      'journal_id[]',
      selected.map((journal) => journal.id)
    );
  };

  const onJournalListChange = () => forceUpdate((n) => n + 1);

  return (
    <div className="Explorer-AdvancedSearch-field-container JournalFilter">
      <label>
        {I18n.t('Explorer.AdvancedSearch.fields.journal.name')}
        <HelpLink
          href={I18n.t('Explorer.AdvancedSearch.help_uri')}
          tip={I18n.t('Explorer.AdvancedSearch.fields.journal.help')}
          analyticsFieldName={ANALYTICS_FIELD_NAME}
        />
      </label>
      <fieldset>
        {loading ? (
          <div>{I18n.t('Explorer.AdvancedSearch.fields.journal.loading')}</div>
        ) : (
          <div>
            {!filterSet.get('journal_list_id') && (
              <AutocompleteField
                name="journal_id"
                id="journal_id"
                type="journals"
                initialValue={initialSearch}
                placeholder={I18n.t('Explorer.AdvancedSearch.fields.journal.placeholder')}
                onChangeItems={updateSelectedJournals}
                initiallySelected={journals}
                ref={autocompleteFieldRef}
                analyticsEventPrefix="Advanced Search: Field"
                analyticsFieldName={ANALYTICS_FIELD_NAME}
              />
            )}
            {!window.current_user.librarian && (
              <JournalList filterSet={filterSet} onChange={onJournalListChange} analyticsDialogueName="Journal ISSNs" />
            )}
          </div>
        )}
      </fieldset>
    </div>
  );
};

JournalFilter.propTypes = {
  filterSet: PropTypes.instanceOf(FilterSet).isRequired,
  initialSearch: PropTypes.string
};

export default JournalFilter;
